<template>
  <v-dialog :value="call || callStarted" persistent>
    <v-card v-if="call">
      <v-card-title>Appel entrant</v-card-title>
      <v-card-text>
        <v-layout justify-center align-center>
          <v-icon class="ring-animation" large>phone</v-icon>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-row actions>
        <v-btn block error light @click.native.stop="reject()" class="mr-2"
          >Rejeter l'appel</v-btn
        >
        <v-btn block success light @click.native.stop="accept()"
          >Accepter l'appel</v-btn
        >
      </v-card-row>
    </v-card>

    <v-card v-else-if="callStarted">
      <v-card-title>Appel en cours</v-card-title>
      <v-card-text>
        <v-layout justify-center align-center>
          <minute :value="duration" />
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-row actions>
        <v-btn block error light @click.native.stop="hangup()"
          >Raccrocher</v-btn
        >
      </v-card-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { Device } from 'twilio-client'
import Credentials from '@/api/credentials'
import { Minute } from '@/components/formatters'
export default {
  components: { Minute },
  data () {
    return {
      identity: null,
      device: null,
      initialized: false,
      call: null,
      callStarted: null,
      time: null,
      date: null
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'skiliko/session/currentUser'
    }),
    duration () {
      if (!this.date || !this.callStarted) return null
      return (this.date - this.callStarted) / 1000
    }
  },
  watch: {
    currentUser () {
      this.initialized = false
      this.initialize()
    }
  },
  methods: {
    async accept () {
      if (!this.call) return
      await navigator.mediaDevices.getUserMedia({ audio: true })
      this.call.accept()
      this.call = null
      this.callStarted = new Date()
      if (!this.timer) {
        this.timer = setInterval((_) => (this.date = new Date()), 1000)
        this.date = new Date()
      }
    },
    reject () {
      if (!this.call) return
      this.call.reject()
      this.call = null
    },
    hangup () {
      if (!this.device) return
      this.call = null
      this.callStarted = null
      this.device.disconnectAll()
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async initialize () {
      if (!this.currentUser) return
      if (this.initialized) return
      this.identity = null
      this.device = null
      this.initialized = false
      try {
        const { data } = await Credentials.phone()
        const { identity, token } = data
        this.identity = identity

        this.device = new Device(token, {
          debug: true,
          answerOnBridge: true,
          codecPreferences: ['opus', 'pcmu']
        })

        this.device.on('registered', () => {
          this.initialized = true
        })
        this.device.on('error', console.error)
        this.device.on('incoming', (call) => {
          this.call = call
          this.call.addListener('error', (err) => {
            console.error(err)
            this.hangup()
          })
          this.call.addListener('disconnect', () => {
            console.log('disconnect')
            this.hangup()
          })
          this.call.addListener('cancel', () => {
            console.log('canceled')
            this.hangup()
          })
          this.call.addListener('reject', () => {
            console.log('reject')
            this.hangup()
          })
          this.call.addListener('transportClose', () => {
            console.log('transportClose')
            this.hangup()
          })
        })

        this.device.register(token)
        this.initialized = true
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.ring-animation {
  animation: ring 2.15s ease-in-out infinite;
  transform-origin-x: 50%;
  transform-origin-y: 0px;
  transform-origin-z: initial
}
@keyframes ring {
  0% { transform: rotate(-12deg) }
  4% { transform: rotate(12deg) }
  8% { transform: rotate(-16deg) }
  12% { transform: rotate(16deg) }
  16% { transform: rotate(-20deg) }
  20% { transform: rotate(20deg) }
  24% { transform: rotate(-16deg) }
  28% { transform: rotate(16deg) }
  32% { transform: rotate(-12deg) }
  36% { transform: rotate(12deg) }
  40% { transform: rotate(0deg) }
}
</style>


// WEBPACK FOOTER //
// src/components/VoipCall.vue